import { AdminCreateMarket, AdminFetchMarkets, AdminRenameMarket } from 'src/constants/actionTypes'
import type { Market } from 'src/interfaces/market'
import { resolveErrorMessage } from 'src/utils/sagaErrorMessage'
import { Action } from 'src/utils/reduxUtils'
import type { MarketState } from './types'

const getInitialState = (): MarketState => {
  return {
    markets: [],
    marketsLoading: false,
    marketsError: null,
    saving: false,
  }
}

export const marketReducer = (
  state: MarketState = getInitialState(),
  action: Action<unknown>,
): MarketState => {
  switch (action.type) {
    case AdminFetchMarkets.type.REQUEST:
      return {
        ...state,
        markets: [],
        marketsLoading: true,
        marketsError: null,
      }
    case AdminFetchMarkets.type.SUCCESS: {
      const markets = (action.payload as Market[] | undefined) ?? []

      return {
        ...state,
        markets,
        marketsLoading: false,
        marketsError: null,
      }
    }
    case AdminFetchMarkets.type.FAILED:
      return {
        ...state,
        marketsLoading: false,
        marketsError: resolveErrorMessage(action.payload, 'Failed to load markets'),
      }

    // Create and rename never write to `markets` — the list is refetched on success, which is
    // the single source of truth. See the design doc's §7.
    case AdminCreateMarket.type.REQUEST:
    case AdminRenameMarket.type.REQUEST:
      return {
        ...state,
        saving: true,
      }
    case AdminCreateMarket.type.SUCCESS:
    case AdminCreateMarket.type.FAILED:
    case AdminRenameMarket.type.SUCCESS:
    case AdminRenameMarket.type.FAILED:
      return {
        ...state,
        saving: false,
      }

    default:
      return state
  }
}
